// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users .info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.users .info button {
  background: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/screens/users/users.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAJ;AAEI;EACE,iBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAAN","sourcesContent":[".users {\n  .info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n\n    button {\n      background: white;\n      padding: 10px;\n      border: none;\n      border-radius: 5px;\n      cursor: pointer;\n      color: #007bff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
